import * as yup from "yup";

const schema = yup.object().shape({
  automaticmessagename: yup.string().min(3, "Minimum 3 characters"),
  automaticmessagedescription: yup.string().min(10, "Minimum 10 characters"),
  automaticmessagetext: yup
    .array()
    .of(
      yup.object().shape({
        text: yup.string().min(10, "Minimum 10 characters"),
      })
    )
    .required("Question is required"),
  automaticmessageskill: yup.string().nullable(true),
  automaticmessagecustomtextskill: yup.array().of(
    yup.object().shape({
      skill_id: yup.string(),
      skill_name: yup.string(),
      text: yup.array().of(
        yup.object().shape({
          text: yup
            .string()
            
            .min(10, "Minimum 10 characters"),
        })
      ).required("Skill question is required"),
    })
  ),
});

export default schema;
